import { AnalystState } from "@/@types/vuex";

export default {
  analysts: {},
} as AnalystState;
